<script setup lang="ts">
  import { CalendarGridHead } from "reka-ui";
</script>

<template>
  <CalendarGridHead>
    <slot />
  </CalendarGridHead>
</template>
